import * as effects from "redux-saga/effects";

import { Backend } from "../../Backend/Backend";
import { ICallState } from "../../Backend/Messages/callSuccess";
import { Logger } from "../../Utils/Logger";
import {
  getPoliticalRegimeSuccess,
  getPoliticalRegimeFailure,
  getPoliticalRegime,
} from "./Actions";
import { IPoliticalRegimeActionTypes, IPoliticalRegime } from "./Types";

function* handleGetPoliticalRegime(
  action: ReturnType<typeof getPoliticalRegime>
) {
  const backend = Backend.getInstance();

  const res: ICallState = yield effects.apply(
    backend,
    backend.getPoliticalRegime,
    [action.payload]
  );
  if (res.status_code === 200) {
    if (res !== null) {
      yield effects.put(
        getPoliticalRegimeSuccess(res.results as IPoliticalRegime[])
      );
    }
  } else {
    Logger.warn("Failed GetPoliticalRegime");
    yield effects.put(getPoliticalRegimeFailure("Failed GetPoliticalRegime"));
  }
}

function* watchPoliticalRegime() {
  yield effects.takeEvery(
    IPoliticalRegimeActionTypes.GET_POLITICAL_REGIME,
    handleGetPoliticalRegime
  );
}

export function* PoliticalRegimeSaga() {
  yield effects.all([effects.fork(watchPoliticalRegime)]);
}
